
            import { clientRenderIsland } from 'virtual:clientRenderIsland.tsx';
            import Component from '/tmp/cms_C49I7A/cms-js-build/customer-package/components/islands/b2bProductsHero/index.tsx';

            export function render(island) {
              return clientRenderIsland(island, Component)
            }

            export default Component;
          